module.exports = __webpack_public_path__ + "static/img/background_new.edf2e18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background_new.png
// module id = ZUZz
// module chunks = 128